import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT } from '@company-box/models';

@Injectable({
  providedIn: "root",
})
export class ConverterService {
  private environment = inject(ENVIRONMENT);
  constructor(private httpClient: HttpClient) {}

  checkFormat(fileName: string) {
    const url = `${this.environment.apiHost}/converter/upload/${fileName}/format`;
    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }

  convert(convertUrl: string, formData: FormData) {
    return new Promise<any>((resolve, reject) => {
      this.httpClient.post(convertUrl, formData).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }

  uploadFile(imageUploadBody: any) {
    const url = `${this.environment.apiHost}/converter/convert`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.post(url, imageUploadBody).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  convertContainerFile(containerId: any, target: any, filename: any, file: any) {
    const url = `${this.environment.apiHost}/converter/convert/container/${containerId}?target=${target}&filename=${filename}`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.post(url, file).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }

  getConvertedContentById(jobId: string) {
    const url = `${this.environment.apiHost}/converter/convert/job/${jobId}/content?`;
    const delay = 1000;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (res) => {
          if (res === null) {
            setTimeout(() => resolve(this.getConvertedContentById(jobId)), delay);
          } else {
            resolve(res);
          }
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }
  getConvertedContent(jobId: string, containerName: string, filename: String) {
    const delay = 2000;
    return new Promise((resolve, reject) => {
      const url = `${this.environment.apiHost}/project/order/job/${jobId}/content?containerName=${containerName}&filename=${filename}`;
      this.httpClient.get(url).subscribe(
        (response) => {
          if (response === null) {
            setTimeout(() => resolve(this.getConvertedContent(jobId, containerName, filename)), delay);
          } else {
            resolve(response);
          }
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  getConvertUrl(target?: any) {
    return `${this.environment.apiHost}/zuul/converter/convert?target=${target || "image/jpg"}`;
  }

  getUploadUrl(containerName: string) {
    return `${this.environment.apiHost}/zuul/converter/upload/${containerName}/content`;
  }
}
